
import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "../api/axiosAuth";
import { useAuth } from "../context/AuthContext";
import { API as BASE_API } from "../components/config"; // ✅ Usando configuración centralizada
import "../style/MisCalificaciones.css";

const API = BASE_API; 

/* ================= NORMALIZADOR ================= */
const normalizarConfig = (raw) => {
  if (!raw) return { items: [], rangos: [], min_nota: 0, max_nota: 5, step: 1 };

  return {
    items: (raw.items || []).map(it => ({
      id: Number(it.id),
      nombre: it.nombre_item || it.nombre,
      porcentaje: Number(it.porcentaje || 0),
      subitems: (it.subitems || [])
        .map(s => ({
          id: Number(s.id),
          orden: Number(s.orden ?? s.id),
          nombre_subitem: s.nombre_subitem
        }))
        .sort((a, b) => a.orden - b.orden)
    })),
    rangos: raw.rangos || [],
    min_nota: Number(raw.min_nota ?? 0),
    max_nota: Number(raw.max_nota ?? 100),
    step: Number(raw.step ?? 1)
  };
};

/* ================= FORMATO ================= */
const formatNota = (nota, maxNota) => {
  if (nota === null || nota === undefined || nota === "") return "";
  const n = Number(nota);
  return maxNota >= 50 ? Math.round(n) : n.toFixed(1);
};

/* ================= COLOR ================= */
const obtenerColorDesempeno = (d) => {
  if (!d) return "#eee";
  switch (d.toLowerCase()) {
    case "superior": return "#4caf50";
    case "alto": return "#8bc34a";
    case "medio": return "#ff9800";
    case "bajo": return "#f44336";
    default: return "blue";
  }
};


export default function CalificacionesProfesor() {
  const { user, token } = useAuth(); // ✅ Token extraído directamente del contexto

  const [asignaciones, setAsignaciones] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [periodo, setPeriodo] = useState(null);
  const [periodoActivo, setPeriodoActivo] = useState(null);

  const [grado, setGrado] = useState("");
  const [grupo, setGrupo] = useState("");
  const [materia, setMateria] = useState("");

  const [config, setConfig] = useState(null);
  const [estudiantes, setEstudiantes] = useState([]);
  const [notas, setNotas] = useState({});

  /* ================= INIT ================= */
//   useEffect(() => {
//     if (!token) return;

//     // axios.get(`${API}/calificaciones/asignaciones`)
//     //   .then(r => setAsignaciones(r.data || []))
//     //   .catch(console.error);

//     // axios.get(`${API}/calificaciones/periodos`)
//     //   .then(r => setPeriodos(r.data || []))
//     //   .catch(console.error);
//     axios.get(`${API}/calificaciones/asignaciones`)
//   .then(({ data }) => {

//     console.log("ASIGNACIONES:", data);

//     setAsignaciones(
//       Array.isArray(data)
//         ? data
//         : Array.isArray(data.asignaciones)
//           ? data.asignaciones
//           : []
//     );

//   })
//   .catch(console.error);

//     // axios.get(`${API}/calificaciones/periodo-activo`)
//     //   .then(r => {
//     //     setPeriodoActivo(r.data);
//     //     setPeriodo(r.data);
//     //   })
//     //   .catch(console.error);

// /* ================= PERIODO ACTIVO ================= */

// axios
//   .get(`${API}/calificaciones/periodo-activo`)
//   .then(({ data }) => {

//     console.log("RESPUESTA PERIODO ACTIVO", data);

//     if (!data.ok) return;

//     setPeriodoActivo(data.periodo);

//     // Seleccionarlo automáticamente
//     setPeriodo(data.periodo);

//   })
//   .catch(err => {
//     console.error("ERROR PERIODO ACTIVO", err);
//   });
//   }, [token]);

/* ================= INIT ================= */
useEffect(() => {

  if (!token) return;

  const cargarDatosIniciales = async () => {

    try {

      /* ==========================================
         ASIGNACIONES
      ========================================== */

      const { data: asignacionesData } = await axios.get(
        `${API}/calificaciones/asignaciones`
      );

      console.log("================================");
      console.log("ASIGNACIONES");
      console.log(asignacionesData);
      console.log("================================");

      setAsignaciones(
        Array.isArray(asignacionesData?.asignaciones)
          ? asignacionesData.asignaciones
          : Array.isArray(asignacionesData)
            ? asignacionesData
            : []
      );

      /* ==========================================
         PERIODOS
      ========================================== */

      const { data: periodosData } = await axios.get(
        `${API}/calificaciones/periodos`
      );

      console.log("================================");
      console.log("PERIODOS");
      console.log(periodosData);
      console.log("================================");

      const listaPeriodos = Array.isArray(periodosData?.periodos)
        ? periodosData.periodos
        : Array.isArray(periodosData)
          ? periodosData
          : [];

      setPeriodos(listaPeriodos);

      /* ==========================================
         PERIODO ACTIVO
      ========================================== */

      const { data: periodoActivoData } = await axios.get(
        `${API}/calificaciones/periodo-activo`
      );

      console.log("================================");
      console.log("PERIODO ACTIVO");
      console.log(periodoActivoData);
      console.log("================================");

      if (periodoActivoData?.ok && periodoActivoData?.periodo) {

        setPeriodoActivo(periodoActivoData.periodo);

        /* Buscar el mismo periodo dentro del arreglo */
        const seleccionado =
          listaPeriodos.find(
            p => Number(p.id) === Number(periodoActivoData.periodo.id)
          ) || periodoActivoData.periodo;

        setPeriodo(seleccionado);

      }

    } catch (err) {

      console.error("Error cargando datos iniciales:", err);

      setAsignaciones([]);
      setPeriodos([]);
      setPeriodo(null);
      setPeriodoActivo(null);

    }

  };

  cargarDatosIniciales();

}, [token]);

  /* ================= CONTROL EDICIÓN 🔥 ================= */
  // const esEditable = periodo && periodoActivo && periodo.id === periodoActivo.id;

  const esEditable =
  Number(periodo?.id) === Number(periodoActivo?.id);

  console.log("periodoActivo", periodoActivo);
console.log("periodo", periodo);
console.log(
  "editable?",
  Number(periodo?.id) === Number(periodoActivo?.id)
);

  /* ================= CONFIG ================= */
  const fetchConfig = useCallback(() => {
    if (!grado || !grupo || !materia || !periodo) return;

    axios.get(`${API}/calificaciones/configuracion`, {
      params: { grado, grupo, materia_id: materia, periodo_id: periodo.id }
    })
      .then(r => setConfig(normalizarConfig(r.data)))
      .catch(console.error);
  }, [grado, grupo, materia, periodo]);

  useEffect(fetchConfig, [fetchConfig]);

  /* ================= ESTUDIANTES ================= */
  // useEffect(() => {
  //   if (!grado || !grupo) return;

  //   axios.get(`${API}/calificaciones/estudiantes`, {
  //     params: { grado, grupo }
  //   })
  //     .then(r => setEstudiantes(r.data || []))
  //     .catch(console.error);
  // }, [grado, grupo]);


 useEffect(() => {

  if (!grado || !grupo) {
    setEstudiantes([]);
    return;
  }

  const cargarEstudiantes = async () => {

    try {

      const { data } = await axios.get(
        `${API}/calificaciones/estudiantes`,
        {
          params: {
            grado,
            grupo
          }
        }
      );

      console.log("================================");
      console.log("RESPUESTA ESTUDIANTES");
      console.log(data);
      console.log("================================");

      if (data.ok && Array.isArray(data.estudiantes)) {

        setEstudiantes(data.estudiantes);

      } else {

        console.warn("El endpoint no devolvió un arreglo de estudiantes.");

        setEstudiantes([]);

      }

    } catch (err) {

      console.error("Error cargando estudiantes:", err);

      setEstudiantes([]);

    }

  };

  cargarEstudiantes();

}, [grado, grupo]);
  /* ================= NOTAS ================= */
  // useEffect(() => {
  //   if (!grado || !grupo || !materia || !periodo) return;

  //   setNotas({});

  //   axios.get(`${API}/calificaciones/notas`, {
  //     params: { grado, grupo, materia_id: materia, periodo_id: periodo.id }
  //   })
  //     .then(res => {
  //       const map = {};
  //       (res.data || []).forEach(n => {
  //         if (!n.subitem_id) return;
  //         map[`${n.estudiante_id}_${n.item_id}_${n.subitem_id}`] = Number(n.calificacion);
  //       });
  //       setNotas(map);
  //     })
  //     .catch(console.error);
  // }, [grado, grupo, materia, periodo]);

useEffect(() => {

    if (!grado || !grupo || !materia || !periodo) return;

    setNotas({});

    axios.get(`${API}/calificaciones/notas`, {
        params: {
            grado,
            grupo,
            materia_id: materia,
            periodo_id: periodo.id
        }
    })
    .then(({ data }) => {

        console.log("RESPUESTA NOTAS");
        console.log(data);

        const listaNotas = Array.isArray(data.notas)
            ? data.notas
            : [];

        const map = {};

        listaNotas.forEach(n => {

            if (!n.subitem_id) return;

            map[
                `${n.estudiante_id}_${n.item_id}_${n.subitem_id}`
            ] = Number(n.calificacion);

        });

        console.log("MAPA NOTAS");
        console.log(map);

        setNotas(map);

    })
    .catch(err => {

        console.error("ERROR CARGANDO NOTAS", err);

        setNotas({});

    });

}, [grado, grupo, materia, periodo]);


  /* ================= SUBITEM ================= */
  const agregarSubItem = async (itemId) => {
    if (!esEditable) return alert("⚠️ Solo puedes editar el periodo activo");

    const nombre = prompt("Nombre del nuevo sub-item:");
    if (!nombre) return;

    try {
      await axios.post(
        `${API}/calificaciones/subitem/agregar`,
        { item_id: itemId, nombre_subitem: nombre },
        { params: { grado, grupo, materia_id: materia, periodo_id: periodo.id } }
      );
      fetchConfig();
    } catch (e) {
      console.error(e);
      alert("Error al agregar subitem");
    }
  };

  /* ================= MANEJO DE NOTAS ================= */
  const setNotaLocal = (eid, itemId, subId, val) => {
    if (!config || !esEditable) return;

    if (val === "") {
      setNotas(prev => {
        const newNotas = { ...prev };
        delete newNotas[`${eid}_${itemId}_${subId}`];
        return newNotas;
      });
      return;
    }

    const num = Number(val);
    if (num < config.min_nota || num > config.max_nota) {
      return; // Silencioso o podrías poner un toast
    }

    setNotas(prev => ({
      ...prev,
      [`${eid}_${itemId}_${subId}`]: num
    }));
  };

  /* ================= PROMEDIOS ================= */
  const promedioItem = (eid, item) => {
    let suma = 0, count = 0;
    item.subitems.forEach(sub => {
      const v = notas[`${eid}_${item.id}_${sub.id}`];
      if (typeof v === "number") {
        suma += v;
        count++;
      }
    });
    if (!count) return "";
    return formatNota(suma / count, config.max_nota);
  };

  const promedioFinal = (eid) => {
    if (!config?.items) return "";
    let total = 0;
    config.items.forEach(item => {
      const pi = promedioItem(eid, item);
      if (pi !== "") {
        total += (Number(pi) * item.porcentaje) / 100;
      }
    });
    return total ? formatNota(total, config.max_nota) : "";
  };

  /* ================= GUARDAR ================= */
  const guardarNotasBatch = async () => {
    if (!esEditable) return alert("⚠️ Solo puedes guardar en el periodo activo");

    const payload = [];
    estudiantes.forEach(est => {
      config.items.forEach(item => {
        item.subitems.forEach(sub => {
          const v = notas[`${est.estudiante_id}_${item.id}_${sub.id}`];
          if (typeof v === "number") {
            payload.push({
              estudiante_id: est.estudiante_id,
              item_id: item.id,
              subitem_id: sub.id,
              calificacion: v
            });
          }
        });
      });
    });

    try {
await axios.post(`${API}/calificaciones/notas`, {
  grado,
  grupo,
  materia_id: materia,
  notas: payload
});
      alert("✅ Notas guardadas correctamente");
    } catch (e) {
      console.error(e);
      alert("Error al guardar");
    }
  };

  return (
    <div className="mis-calificaciones-container">
      <h2>📘 Calificaciones</h2>

      <div className="flex gap-2">
        <select value={grado} onChange={e => setGrado(e.target.value)}>
          <option value="">Grado</option>
          {[...new Set(asignaciones.map(a => a.grado))].map(g => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>

        <select value={grupo} onChange={e => setGrupo(e.target.value)}>
          <option value="">Grupo</option>
          {[...new Set(asignaciones.filter(a => a.grado === grado).map(a => a.grupo))].map(g => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>

        <select value={materia} onChange={e => setMateria(e.target.value)}>
          <option value="">Materia</option>
          {asignaciones
            .filter(a => a.grado === grado && a.grupo === grupo)
            .map(a => (
              <option key={a.materia_id} value={a.materia_id}>
                {a.nombre_materia}
              </option>
            ))}
        </select>
     <select
    value={periodo?.id || ""}
    onChange={(e) => {
        const p = periodos.find(
            x => Number(x.id) === Number(e.target.value)
        );

        setPeriodo(p || null);
    }}
>
    <option value="">Seleccione periodo</option>

    {periodos.map((p) => (
        <option key={p.id} value={p.id}>
            {p.nombre}
        </option>
    ))}
</select>

      </div>

      {!esEditable && periodo && (
        <p className="lectura-only-msg">🔒 Modo solo lectura (periodo cerrado o no activo)</p>
      )}

      {config?.items?.length > 0 && (
        <>
          <table className="calificaciones-table">
            <thead>
              <tr>
                <th rowSpan="2">Estudiante</th>
                {config.items.map(item => (
                  <th key={item.id} colSpan={item.subitems.length + 1}>
                    {item.nombre} ({item.porcentaje}%)
                    {esEditable && <button className="btn-add-sub" onClick={() => agregarSubItem(item.id)}>➕</button>}
                  </th>
                ))}
                <th rowSpan="2">Final</th>
                <th rowSpan="2">Desempeño</th>
              </tr>
              <tr>
                {config.items.map(item => (
                  <React.Fragment key={item.id}>
                    {item.subitems.map(sub => (
                      <th key={sub.id} className="subitem-header">{sub.nombre_subitem}</th>
                    ))}
                    <th className="prom-header">Prom</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {estudiantes.map(est => {
                const pf = promedioFinal(est.estudiante_id);
                const rango = config.rangos.find(r => Number(pf) >= r.nota_min && Number(pf) <= r.nota_max)?.desempeno;

                return (
                  <tr key={est.estudiante_id}>
                    <td className="estudiante-name">{est.apellidos_estudiante} {est.nombres_estudiante}</td>
                    {config.items.map(item => (
                      <React.Fragment key={item.id}>
                        {item.subitems.map(sub => (
                          <td key={sub.id}>
                            <input
                              type="number"
                              disabled={!esEditable}
                              min={config.min_nota}
                              max={config.max_nota}
                              step={config.step}
                              value={notas[`${est.estudiante_id}_${item.id}_${sub.id}`] ?? ""}
                              onChange={e => setNotaLocal(est.estudiante_id, item.id, sub.id, e.target.value)}
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={(e) => {
                                const inputs = Array.from(document.querySelectorAll("input[type='number']"));
                                const index = inputs.indexOf(e.target);
                                if (e.key === "ArrowDown" || e.key === "Enter") {
                                  e.preventDefault();
                                  inputs[index + 1]?.focus();
                                } else if (e.key === "ArrowUp") {
                                  e.preventDefault();
                                  inputs[index - 1]?.focus();
                                }
                              }}
                            />
                          </td>
                        ))}
                        <td className="cell-prom">{promedioItem(est.estudiante_id, item)}</td>
                      </React.Fragment>
                    ))}
                    <td className="cell-final">{pf}</td>
                    <td style={{ backgroundColor: obtenerColorDesempeno(rango), color: '#fff', fontWeight: 'bold' }}>
                      {rango}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {esEditable && (
            <button className="btn-guardar" onClick={guardarNotasBatch}>💾 Guardar Notas</button>
          )}
        </>
      )}
    </div>
  );
}